import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createCookie, readCookie } from '../../utils/Cookie';
import { login, generateLoginOTP } from '../actions/signinAction';
import { validateMobile, validateEmail } from '../../utils/inputValidator';
import { hideModal } from '../../actions/modal.js';
import OTPComponent from './OTPComponent';
import SetPassword from './SetPassword';
import cleverTapPushEvent from '../../modules/ajio-util/cleverTap/eventUtils';
import CLEVERTAP_EVENT_NAMES from '../../modules/ajio-util/cleverTap/eventConstants';
import { createRedirectUri } from '../../utils/redirectUtil';
import { signInCheck } from '../../components/common/CheckUserStatus';
import screen from '../../utils/pageType';
import { gtmEventPush, gtmPagePush, segmentEventPush } from '../../modules/ga/GTMdatalayer';
import { getShowOtpMessageForMobile, getShowOtpMessageForEmail } from '../../Flags/selectors.js';
import { parseSearch } from '../../modules/ajio-util/query';
import OldPasswordComponent from './OldPasswordComponent';

import { getLuxeFlags } from '../../Flags/selectors';
import { getCurrentStore } from '../../refresh/selectors/metaData';

class SignInWithOTP extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.inputLoginPassword = this.inputLoginPassword.bind(this);
    this._resendOTP = this.resendOTP.bind(this);
    this.state = {
      otp: '',
      errorMsg: '',
      setPwd: false,
      showTimer: true,
      setPwdClicked: false,
      pwdComponent: false
    };
    this.userInfo = props.userCred;
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.errMsg !== prevState.errorMsg) {
      return {
        errorMsg: nextProps.errMsg,
      };
    }
    return null;
  }

  componentDidMount() {
    if (readCookie('uI')) {
      this.userInfo = decodeURIComponent(readCookie('uI'));
    } else {
      this.userInfo = this.props.userCred;
    }
    const loginStatus = signInCheck().length ? 'Login' : 'Not Login';
    const { login_otp: { pageType = '', pageName = '' } = {} } = screen;
    const { location: { search = '' } = {} } = window;
    const queryObj = parseSearch(search) || '';
    const { referrer = '', login_source = '' } = queryObj;
    const { setPwd } = this.state;
    localStorage.setItem('LoginModelType', 'login - otp screen');
    localStorage.setItem('LoginBackButtonType', 'login - otp screen');
    if (this.state.setPwd) {
      gtmEventPush({
        event: 'pageload',
        login_method: 'OTP',
        referral_page: referrer.slice(1),
        login_source,
        user_type: loginStatus,
        page_type: pageType,
        page_name: 'login - otp screen'
      });
    }
  }

  handleSubmit(event, userData, destination) {
    let { location: { pathname = '' } = {}, queryString = '' } = this.props;
    event.preventDefault();
    var signInObj = {};
    signInObj = {
      username: userData,
      otp: this.state.otp,
      device: this.props.viewSiteAs
    };
    if (this.state.otp !== '') {
      this.props.login(signInObj, () => {
        if (this.props.validUser) {
          ga('send', {
            eventCategory: 'Login',
            eventAction: 'Sign in with OTP',
            eventLabel: 'Continue - Success'
          });
          const loginStatus = signInCheck().length ? 'Login' : 'Not Login';
          const { login_otp: { pageType = '', pageName = '' } = {} } = screen;
          const { location: { search = '' } = {} } = window;
          const queryObj = parseSearch(search) || '';
          const { referrer = '', login_source = '' } = queryObj;
          gtmEventPush({
            event: 'login_success',
            login_method: 'OTP',
            referral_page: referrer.slice(1),
            login_source,
            user_type: loginStatus,
            page_type: pageType,
            page_name: 'login - otp screen'
          });
          // segment Push event
          
          segmentEventPush({
            event: 'Login or Signup Successful',           
            gender : '',
            referral_code: this.props.referrerDetails?.referralCode,
            screen_name: 'login - otp screen',
            type: 'login'
          });

          gtmEventPush({
            page_type: 'user account screen',
            event: 'user_account_interactions',
            action: 'OTP',
            label: 'Start shopping - success',
            login_source
          });
          cleverTapPushEvent({
            eventName: CLEVERTAP_EVENT_NAMES.User_Sign_In,
            eventObj: {
              source: 'Sign In Page',
              type: 'Login Via EMail Id and OTP',
              user_id: userData,
              platform: 'MSITE'
            }
          });
          const redirectURI = createRedirectUri(queryString);
          this.setState({ errorMsg: '' });
          if (this.props.viewSiteAs == 'desktop') {
            if (pathname == '/login' || pathname == '/login/otp') {
              window.location = redirectURI;
            } else {
              // close modal
              if (!this.state.setPwdClicked) this.props.hideModal('sign-in-up');
              let { location: { href = '' } = {} } = window;
              if (!href.includes('/cart')) {
                window.location.reload();
              }
            }
          } else {
            window.location = redirectURI;
          }
        }
        if (this.props.statusCode == 400 || this.props.statusCode === 403) {
          ga('send', {
            eventCategory: 'Login',
            eventAction: 'Sign in with OTP',
            eventLabel: 'Continue - Failure'
          });
          let erMsg = 'Invalid OTP';
          if (this.props.errMsg.includes('exceeded')) {
            // erMsg = "OTP has expired";
            erMsg = 'You have exceeded maximum OTP attempts, Please try again after some time.';
          }
          if (this.props.errMsg.includes('locked')) {
            erMsg = this.props.errMsg;
          }
          this.setState({
            errorMsg: this.props.statusCode === 403 ? this.props.errMsg : erMsg,
            showTimer: false
          });
          gtmEventPush({
            page_type: 'user account screen',
            event: 'user_account_interactions',
            action: 'OTP',
            label: 'Start shopping - failure'
          });
        }
      });
    } else {
      this.setState({
        errorMsg: 'Please enter a valid OTP',
        showTimer: true
      });
      gtmEventPush({
        page_type: 'user account screen',
        event: 'formError',
        action: 'formError',
        label: 'Please enter a valid OTP'
      });
    }
  }

  setNewPwd(userData, destination) {
    let { hideLoader = false, queryString = '' } = this.props;
    this.setState({
      setPwdClicked: true,
      showTimer: false
    });
    var signInObj = {};
    signInObj = {
      username: userData,
      otp: this.state.otp,
      device: this.props.viewSiteAs,
      loader: true
    };
    if (this.state.otp !== '') {
      this.props.login(signInObj, () => {
        const { history = {} } = this.props;
        if (this.props.validUser) {
          ga('send', {
            eventCategory: 'Login',
            eventAction: 'Set password',
            eventLabel: 'Continue - Success'
          });
          this.setState({ errorMsg: '' });
          if (this.props.viewSiteAs == 'desktop') {
            this.setState({
              setPwd: true
            });
          } else {
            history.push({
              pathname: '/login/password-set',
              search: queryString,
              state: {
                otp: this.state.otp
              }
            });
          }
        }
        if (this.props.statusCode == 400 || this.props.statusCode === 403) {
          ga('send', {
            eventCategory: 'Login',
            eventAction: 'Set password',
            eventLabel: 'Continue - Failure'
          });
          let erMsg = 'Invalid OTP';
          if (this.props.errMsg.includes('exceeded')) {
            erMsg = 'You have exceeded maximum OTP attempts, Please try again after some time.';
          }
          if (this.props.errMsg.includes('locked')) {
            erMsg = this.props.errMsg;
          }
          this.setState({
            errorMsg: this.props.statusCode === 403 ? this.props.errMsg : erMsg,
            showTimer: false
          });
        }
      });
    } else {
      this.setState({
        errorMsg: 'Please enter a valid OTP',
        showTimer: true
      });
    }
  }

  getOTPforAuthCB = otpValue => {
    this.setState({ otp: otpValue });
  };

  resendOTP() {
    let userInfo = decodeURIComponent(readCookie('uI'));
    if (validateMobile(userInfo)) {
      userInfo = { mobileNumber: userInfo };
    } else if (validateEmail(userInfo)) {
      userInfo = { emailId: userInfo };
    }
    this.props.generateLoginOTP(userInfo, () => {
      let { success, message } = this.props.otpResponseObj;
      if (!success && message) {
        this.setState({ errorMsg: message });
      }
    });
  }

  resendOTPforAuthCB = () => {
    let { userCred = '' } = this.props;
    ga('send', {
      eventCategory: 'Login',
      eventAction: 'Sign in with OTP',
      eventLabel: 'Resend OTP'
    });
    if (this.props.viewSiteAs == 'desktop') {
      this._resendOTP();
    } else {
      // this.props.generateLoginOTP(this.props.location.state.userData);
      // console.log(this.props);
      if (this.props.location.state) {
        this.props.generateLoginOTP(this.props.location.state.userData);
      } else {
        this.props.generateLoginOTP({ mobileNumber: userCred });
      }
    }
    this.setState({
      errorMsg: '',
      showTimer: true
    });
  };

  inputLoginPassword() {
    if (this.props.viewSiteAs == 'desktop') {
      this.setState({
        pwdComponent: true
      });
    }
    gtmPagePush('login password screen', 'user account screen', window.__ENV__ || '');
  }

  render() {
    const newDesignLuxe = this.props.newDesignLuxe;

    const {
      validUser = false,
      maskedMobileNumber = '',
      maskedEmailId = '',
      viewSiteAs = '',
      queryString = '',
      userCred = '',
      otp_popup_display_mobile,
      otp_popup_display_email,
      resetPasswordFirstLogin
    } = this.props;
    let maskedEmail = maskedEmailId || readCookie('mE');
    let maskedNumber = maskedMobileNumber || readCookie('mN');
    if (this.state.pwdComponent) {
      console.log('PASSWORD COMPOENNET');
      return (
        <OldPasswordComponent
          viewSiteAs={viewSiteAs}
          userCred={this.state.userCred}
          newDesignLuxe={newDesignLuxe}
          queryString={queryString}
        />
      );
    } else if (this.state.setPwd) {
      return <SetPassword otp={this.state.otp} viewSiteAs={viewSiteAs} queryString={queryString} />;
    } else {
      return (
        <div>
          <form
            className={`${newDesignLuxe ? 'luxe-newdesign' : ''} login-form`}
            onSubmit={e => this.handleSubmit(e, this.userInfo, '/')}
            data-ga-event-category="Login"
            data-ga-event-action="Sign in with OTP "
            data-ga-event-label="Screen Launch"
          >
            <h1>Sign In with OTP</h1>
            <h2 className="login-form-inputs masked-cred">Please enter OTP sent to</h2>
            {otp_popup_display_email ? (
              <div className="masked-txt">{decodeURIComponent(maskedEmail)}</div>
            ) : null}
            {otp_popup_display_mobile ? (
              <h3 className="login-form-inputs masked-cred masked-txt">+91 {maskedNumber}</h3>
            ) : null}

            <OTPComponent
              newDesignLuxe={newDesignLuxe}
              getOTP={this.getOTPforAuthCB}
              resendOTP={this.resendOTPforAuthCB}
              viewSiteAs={viewSiteAs}
              showTimer={this.state.showTimer}
              errorMsg={this.state.errorMsg}
              pageNameLoginOTP="login - otp screen"
            />
            <div>
              <input
                type="submit"
                className="login-form-inputs login-btn"
                value="START SHOPPING"
                onClick={() => {
                  gtmEventPush({
                    page_type: 'user account screen',
                    event: 'user_account_interactions',
                    category: 'user account interactions',
                    action: 'Start shopping'
                  });
                }}
              />
            </div>

            {resetPasswordFirstLogin ? <div /> : null
            }

            {/* <div className="login-form-inputs">
              Would you like to set a new password?
            </div>

            <div >
              <input type="button"
                className=  "login-form-inputs only-border-btn"
                value="SET NEW PASSWORD"
                onClick = {() =>{
                  gtmEventPush({
                  event: 'link_click',
                  screen_type: `login otp`,
                  link_text: `Set New password`,
                  user_login_step:3,
                  page_type: 'login',
                  page_name: 'login'
                });
                  this.setNewPwd(this.userInfo, "password-set")
                  //set password
                }} />
            </div> */}
          </form>
        </div>
      );
    }
  }
}

const mapDispatchToProps = dispatch => {
  return {
    login: (formData, callback) => {
      dispatch(login(formData, callback));
    },
    hideModal: name => {
      dispatch(hideModal(name));
    },
    generateLoginOTP: (mobile, callbackOtp) => {
      dispatch(generateLoginOTP(mobile, callbackOtp));
    }
  };
};

const mapStateToProps = (state, ownProps) => {
  const { signInReducer = {}, httpError = {}, signInOTPReducer = {}, flags = {}, referAndEarn = {} } = state;
  const {
    validUser = false,
    maskedMobileNumber = '',
    maskedEmailId = '',
    resetPasswordFirstLogin = true
  } = signInReducer;
  const { error = {} } = httpError;
  const { statusCode = '', message = '' } = error;
  console.log('error in sign-in OTP', error);
  const { otpResponseObj = {} } = signInOTPReducer;
  const { referrerDetails = {} } = referAndEarn;

  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);

  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';

  return {
    httpError,
    validUser,
    statusCode,
    maskedEmailId,
    maskedMobileNumber,
    errMsg: message,
    otp_popup_display_mobile: getShowOtpMessageForMobile(flags),
    otp_popup_display_email: getShowOtpMessageForEmail(flags),
    resetPasswordFirstLogin,
    newDesignLuxe,
    otpResponseObj,
    referrerDetails
  };
};

export default SignInWithOTP = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SignInWithOTP)
);
